const {
    SOURCE_MM,
  } = require('./../../../../sourceList'),
  {
    CR_6,
  } = require('./../../../../crList'),
  {
    SIZE_MEDIUM,
  } = require('./../../../../sizeList'),
  {
    CREATURE_TYPE_GITH,
    CREATURE_TYPE_GITHZERAI,
    CREATURE_TYPE_HUMANOID,
  } = require('./../../../../creatureTypeIdList'),
  {
    ALIGNMENT_LN,
  } = require('./../../../../aligmentList'),
  {
    SPEED_WALK,
  } = require('./../../../../speedList'),
  {
    ATTACK_MELEE_WEAPON,
  } = require('./../../../../attackTypeList'),
  {
    LANG_GITH,
  } = require('./../../../../languageIdList'),
  {
    DAMAGE_BLUDGEONING,
    DAMAGE_PSYCHIC,
  } = require('./../../../../damageTypeList'),
  {
  } = require('./../../../../senseList'),
  {
    SKILL_ARCANA,
    SKILL_INSIGHT,
    SKILL_PERCEPTION,
  } = require('./../../../../skillList'),
  {
    PARAM_STR,
    PARAM_DEX,
    PARAM_CON,
    PARAM_INT,
    PARAM_WIT,
    PARAM_CHA,
  } = require('./../../../../paramList'),
  {
    SPELL_FEATHER_FALL,
    SPELL_JUMP,
    SPELL_MAGE_HAND,
    SPELL_PHANTASMAL_KILLER,
    SPELL_PLANE_SHIFT,
    SPELL_SEE_INVISIBILITY,
    SPELL_SHIELD,
  } = require('./../../../../spellIdList'),
  {
    CAST_MATERIAL,
    CAST_NONE,
  } = require('./../../../../castComponentList'),
  {
    GENDER_MALE,
  } = require('./../../../../genderList'),
  {
    PROF_DOUBLE,
    PROF_NORMAL,
  } = require('./../../../../proficiencyList'),
  {
    githzeraiDescription,
    githNote,
  } = require('./../../../../textCommonParts'),
  {
    CREATURE_GITHZERAI_ZERTH,
  } = require('./../../../../creatureIdList')

module.exports = {
  name: 'Гитцерай зерт',
  nameEn: 'Githzerai Zerth',
  id: CREATURE_GITHZERAI_ZERTH,
  description: [
    `Опытных монахов гитцераев, лучше всего воплощающих учения и принципы Зертимона, зовут зертами. Эти могущественные и дисциплинированные монахи могут перемещать свои тела с одного плана на другой, используя лишь силу разума.`,
    ...githzeraiDescription,
  ],
  note: githNote,
  sizeType: SIZE_MEDIUM,
  creatureTypeIdList: [
    CREATURE_TYPE_HUMANOID,
    CREATURE_TYPE_GITH,
    CREATURE_TYPE_GITHZERAI,
  ],
  alignmentId: ALIGNMENT_LN,
  source: {
    id: SOURCE_MM,
    page: 58,
  },
  armor: 17,
  hp: {
    diceCount: 13,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 13,
    [PARAM_DEX]: 18,
    [PARAM_CON]: 15,
    [PARAM_INT]: 16,
    [PARAM_WIT]: 17,
    [PARAM_CHA]: 12,
  },
  saveThrowList: [
    PARAM_STR,
    PARAM_DEX,
    PARAM_INT,
    PARAM_WIT,
  ],
  skillCollection: {
    [SKILL_PERCEPTION]: PROF_NORMAL,
    [SKILL_ARCANA]: PROF_NORMAL,
    [SKILL_INSIGHT]: PROF_NORMAL,
  },
  languageList: [
    LANG_GITH,
  ],
  cr: CR_6,
  featureList: [
    {
      name: 'Психическая защита',
      description: `Пока ★СУЩЕСТВО★ не носит доспех и не использует щит, к ★его★ КД добавляется модификатор Мудрости.`,
    },
  ],
  spellCast: {
    comment: 'псионика',
    baseStat: PARAM_WIT,
    componentExclude: CAST_NONE,
    spellIdByCountList: [
      {
        limit: Infinity,
        list: [
          {
            id: SPELL_MAGE_HAND,
            comment: 'рука невидима',
          },
        ],
      },
      {
        limit: {
          count: 3,
          period: 'день',
        },
        list: [
          SPELL_SEE_INVISIBILITY,
          SPELL_FEATHER_FALL,
          SPELL_JUMP,
          SPELL_SHIELD,
        ],
      },
      {
        limit: {
          count: 1,
          period: 'день',
        },
        list: [
          SPELL_PHANTASMAL_KILLER,
          SPELL_PLANE_SHIFT,
        ],
      },
    ],
  },
  actionList: [
    {
      name: 'Мультиатака',
      description: `★СУЩЕСТВО★ совершает две атаки _Безоружным ударом_.`,
    },
    {
      name: 'Безоружный удар',
      description: `Это считается атакой магическим оружием.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 7,
        range: 5,
        hit: [
          {
            type: DAMAGE_BLUDGEONING,
            diceCount: 2,
            diceType: 6,
            diceBonus: 4,
          },
          {
            type: DAMAGE_PSYCHIC,
            diceCount: 3,
            diceType: 8,
          },
        ],
      },
    },
  ],
  genderId: GENDER_MALE,
}
